
import Vue from 'vue';
import GlassButton from '@/components/base/GlassButton.vue';

/**
 * The Refresh button beside a list's Filter button. The lists read a copy of the
 * data that trails live changes by a few seconds, so a board or member created a
 * moment ago can be missing from the list; this asks for it again without leaving
 * the page. The host does the fetching, and passes `refreshing` while it does,
 * which turns the icon into a spinner and ignores further clicks.
 */
export default Vue.extend({
	name: 'RefreshListButton',
	props: {
		refreshing: { type: Boolean, default: false },
	},
	methods: {
		onClick () {
			if (this.refreshing) return;
			this.$emit('click');
		},
	},
	components: {
		GlassButton,
	},
});
